import {
  advancePaymentStatusColors,
  classNames,
} from "../utils/formatters";
import { useCallback, useState } from "react";

import ConfirmModal from "./ConfirmModal";
import { authState } from "../state/atoms";
import { useRecoilState } from "recoil";

const AdvancePaymentStatus = ({ submission, handleAction }: any) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("");
  const [message, setMessage] = useState("Are you sure?");
  const [auth]: any = useRecoilState(authState);

  const userEmail = auth && auth.attributes && auth.attributes.email;
  const isAdmin = submission && submission.admins.includes(userEmail);

  const showModal = useCallback((action, message) => {
    console.log("showModal", action, message);
    setAction(action);
    setMessage(message);
    setModalOpen(true);
  }, []);

  const isApproveDisabled = () => {
    if (isAdmin && submission.advancePaymentStatus === 'Needs Review') {
      return false;
    }
    return true;
  }

  const isWithdrawDisabled = () => {
    if (
      isAdmin &&
      (submission.advancePaymentStatus === "Needs Review" ||
        submission.advancePaymentStatus === "Approved")
    ) {
      return false;
    }
    return true;
  }

  return (
    <>
      <div className="mb-2 font-semibold">Advance Payment Status</div>
      <span
        className={classNames(
          advancePaymentStatusColors[submission.advancePaymentStatus],
          "px-4 py-3 inline-flex w-full justify-center leading-5 font-semibold rounded shadow-sm mb-4"
        )}
      >
        {submission.advancePaymentStatus}
      </span>
      <div>
        <div className="flex justify-end mb-4">
          <button
            disabled={isApproveDisabled()}
            onClick={() =>
              showModal(
                "approve-advance",
                "Approving this advance payment request will change the status from 'Needs Review' to 'Approved'. This should only be required when the applicant has income-based assistance programs selected."
              )
            }
            className="w-full bg-gradient-to-b from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 mr-1  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-green-500"
          >
            Approve
          </button>
          <button
            disabled={isWithdrawDisabled()}
            onClick={() =>
              showModal(
                "withdraw-advance",
                "Withdrawing this advance will mark the application as withdrawn. This will indicate that the individual will not be eligible for an advance payment."
              )
            }
            className="w-full ml-1  bg-gradient-to-b from-red-600 to-red-700 hover:from-red-500 hover:to-red-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-red-500"
          >
            Withdraw
          </button>
        </div>
      </div>
      {modalOpen && (
        <ConfirmModal
          message={message}
          handleClose={() => {
            setModalOpen(false);
          }}
          handleAction={() => {
            console.log("handleAction", action);
            handleAction(action);
          }}
        />
      )}
    </>
  );
};

export default AdvancePaymentStatus;
